<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('trainingtimes.Header') }}</h2>
                <br />
                {{ $t('trainingtimes.Text') }}<a href="mailto:info@tsg-bochum.de">info@tsg-bochum.de</a>.
                <br />
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <h3>{{ $t('trainingtimes.TableHeader') }}</h3>
            <div id="gridTrainingtimes">
                <kendo-datasource ref="datasourceTrainingszeiten"
                                  :transport-read-url="urlTimes"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourceTrainingszeiten'"
                            :toolbar="['pdf']"
                            :mobile="true"
                            ref="grid"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('trainingtimes.Header')"
                            :pdf-title="$t('trainingtimes.Header')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Wochentag'"
                                       :title="$t('trainingtimes.TimesColumnHeaderWeekday')"
                                       :minResizableWidth="100"></kendo-grid-column>
                    <kendo-grid-column :field="'Zeiten'"
                                       :title="$t('trainingtimes.TimesColumnHeaderTrainingtimes')"
                                       :minResizableWidth="120"></kendo-grid-column>
                    <kendo-grid-column :field="'Gruppe'"
                                       :title="$t('trainingtimes.TimesColumnHeaderTraininggroup')"
                                       :minResizableWidth="230"></kendo-grid-column>
                    <kendo-grid-column :field="'Trainingsinhalt'"
                                       :title="$t('trainingtimes.TimesColumnHeaderTrainingcontent')"
                                       :minResizableWidth="200"></kendo-grid-column>
                    <kendo-grid-column :field="'Halle'"
                                       :title="$t('trainingtimes.TimesColumnHeaderTraininghall')"
                                       :minResizableWidth="200"></kendo-grid-column>
                </kendo-grid>
            </div>
            <div>{{ dateInfo }}</div>
            <br />
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            urlTimes: String
        },
        data: function () {
            return {
                theImage: '',
                schemaModelFields: {
                    Wochentag: { validation: { required: true } },
                    Zeiten: { validation: { required: true } },
                    Gruppe: { validation: { required: true } },
                    Trainingsinhalt: { validation: { required: true } },
                    Halle: { validation: { required: true } },
                }
            }
        },
        computed: {
            dateInfo() {
                return this.getDateInfo()
            }
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            const grid = this.$refs.grid.kendoWidget();
            $.each(grid.columns, function (index, column) {
                grid.resizeColumn(column, column.minResizableWidth);
            });
        },
        created() {
            this.urlTimes = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Trainingszeiten"
        },
        methods: {
            getWeekNumber(d) {
                // Copy date so don't modify original
                d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
                // Set to nearest Thursday: current date + 4 - current day number
                // Make Sunday's day number 7
                d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
                // Get first day of year
                var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
                // Calculate full weeks to nearest Thursday
                var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
                // Return array of year and week number
                var dateformated = new Date(Date.now()).toLocaleString().split(',')[0];
                // Return Date formated
                var evenOdd = ''
                if (weekNo % 2 == 0)
                    evenOdd = '(gerade)';
                else
                    evenOdd = '(ungerade)';
                return [d.getUTCFullYear(), weekNo, dateformated, evenOdd];
            },
            getDateInfo() {
                var result = this.getWeekNumber(new Date());
                var dateInfo = 'Aktuelles Datum: ' + result[2] + ' - Kalenderwoche: ' + result[1] + ' ' + result[3];
                return dateInfo;
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>